import { useContext } from '@nuxtjs/composition-api';

const SITES_WITH_NO_LANG_SWITCHER = [
  'https://www.asbis.am',
  'https://www.asbis.az',
  'https://www.asbis.ee',
  'https://www.asbis.ge',
  'https://www.asbis.lt',
  'https://www.asbis.lv',
  'https://www.asbis.md',
];

export const checkHasSiteLangSwitch = () => {
  const { $config } = useContext();

  return !SITES_WITH_NO_LANG_SWITCHER.includes($config.baseUrl);
};
